export default {
  CLIENT_PORTAL_LOGO: "client-portal-logo"
};